import React = require("react");
import { Flex } from "../compositeComponents/FlexHelpers";
import { DateInputField } from "./DateInputField";
import { TimeInputField } from "./TimeInputField";
import { maybeAdjustEnd, maybeAdjustStart } from "./StartEndDateTimeFields";
import { Label } from "../Label";



type DateTimeStartEndFieldsProps = {
    start: Date,
    end: Date,
    hideLabels?:boolean,
    layoutDirection?: 'row' | 'column',

    onChanged: (start: Date, end: Date) => void
}
export function DateTimeStartEndFields(props:DateTimeStartEndFieldsProps): JSX.Element {

    function handleStartDateChange(value: Date | null) {
        if(value === null) return;
        const newStart = new Date(value.getFullYear(), value.getMonth(), value.getDate(), props.start.getHours(), props.start.getMinutes(), 0, 0);
        const { start, end } = maybeAdjustEnd(props.start, newStart, props.end);
        props.onChanged(start, end);
    }

    function handleEndDateChange(value: Date | null) {
        if(value === null) return;
        const newEnd = new Date(value.getFullYear(), value.getMonth(), value.getDate(), props.end.getHours(), props.end.getMinutes(), 0, 0);
        const { start, end } = maybeAdjustStart(props.start, props.end, newEnd);
        props.onChanged(start, end);
    }

    function handleStartTimeChange(value: Date | null) {
        if(value === null) return;
        const newStart = new Date(props.start.getFullYear(), props.start.getMonth(), props.start.getDate(), value.getHours(), value.getMinutes(), 0, 0);
        const { start, end } = maybeAdjustEnd(props.start, newStart, props.end);
        props.onChanged(start, end);
    }

    function handleEndTimeChange(value: Date | null) {
        if(value === null) return;
        const newEnd = new Date(props.end.getFullYear(), props.end.getMonth(), props.end.getDate(), value.getHours(), value.getMinutes(), 0, 0);
        const { start, end } = maybeAdjustStart(props.start, props.end, newEnd);
        props.onChanged(start, end);
    }


    return (
        // Make it fill two columns
        <>
            <Flex flexDirection={props.layoutDirection === "row" ? "row" : "column"} gap={16} flexWrap="wrap">
                <Flex flexDirection="row" alignItems="flex-end" style={{minWidth: 'min-content'}}>
                    <Flex flexDirection="column">
                        <Label>Fra</Label>
                        <DateInputField
                            hideLabel
                            value={props.start}
                            onValueChange={handleStartDateChange}
                            label={""}
                            validator={() => { return { valid: true } }} />    
                    </Flex>
                    <TimeInputField
                        hideLabel
                        value={props.start}
                        label={""}
                        onValueChange={handleStartTimeChange}
                        validator={() => { return { valid: true } }} />
                </Flex>

                <Flex flexDirection="row" alignItems="flex-end" style={{minWidth: 'min-content'}}>
                    <Flex flexDirection="column">
                        <Label>Til</Label>
                        <DateInputField
                            hideLabel
                            value={props.end}
                            onValueChange={handleEndDateChange}
                            label={""}
                            validator={() => { return { valid: true } }} />
                    </Flex>
                    <TimeInputField
                        hideLabel
                        value={props.end}
                        label={""}
                        onValueChange={handleEndTimeChange}
                        validator={() => { return { valid: true } }} />
                </Flex>
            </Flex>
        </>
    );
}


export function isSameDate(start: Date, end: Date) {
    const startDate = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0);
    const endDate = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 0, 0, 0);
    return startDate.getTime() === endDate.getTime();
}